import { render } from "./frontPage.vue?vue&type=template&id=24cb4d2d"
import script from "./frontPage.vue?vue&type=script&lang=js"
export * from "./frontPage.vue?vue&type=script&lang=js"

import "./frontPage.vue?vue&type=style&index=0&id=24cb4d2d&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__